import { combineReducers } from "redux";
import formSlice from "../pages/Form/formSlice";
import loginSlice from "../pages/Login/loginSlice";
import registerSlice from "../pages/Register/registerSlice";
import draftSlice from "../pages/Form/draftSlice";

const appReducer = combineReducers({
  register: registerSlice,
  login: loginSlice,
  form: formSlice,
  drafts: draftSlice,
});

export const rootReducer = (state, action) => {
  return appReducer(state, action);
};
